import React from 'react'
import PropTypes from 'prop-types'

const PhoneSecurityLockSymbol = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 129 128`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.1414 11.0138L116.203 89.5997C119.93 92.6647 120.607 98.5495 117.671 102.473C116.316 104.312 114.396 105.538 112.25 105.905L30.5954 118.901C25.9649 119.636 21.6732 116.204 20.9956 111.055C20.9956 111.055 20.9956 111.055 20.9956 110.932L9.58883 19.4731C8.9112 14.4465 12.1864 9.78778 16.8169 9.05219C19.0757 8.80699 21.3344 9.41999 23.1414 11.0138Z"
      fill="#DEF9CC"
    />
    <path
      d="M56.2623 41.5208L57.8545 52.8496L48.5766 54.1535L46.8197 41.6527C46.8197 41.6527 43.959 17.7546 67.1049 14.5017C90.2508 11.2487 94.3156 33.0854 94.3156 33.0854L96.347 47.5394L86.9714 48.857L84.9675 34.5984C84.9675 34.5984 81.9273 22.1784 69.1336 23.9765C56.3399 25.7745 55.8812 37.3915 56.2623 41.5208Z"
      fill="#8CE563"
    />
    <path
      d="M51.542 50.4502L51.9675 53.4777"
      stroke="white"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M97.3612 47.0157L46.8388 54.1161C36.9455 55.5065 33.3503 62.2596 34.4267 69.9181L39.0414 102.754C40.1043 110.317 47.2868 115.148 55.2588 114.027L105.781 106.927C113.653 105.82 119.713 101.939 117.273 91.7592L112.658 58.9234C111.347 49.5943 107.75 45.5557 97.3612 47.0157ZM80.7615 81.4662C80.5891 81.6857 80.4167 81.9052 80.4571 82.1924L81.6141 90.4252C81.8832 92.3399 80.5175 94.1914 78.4249 94.4855L77.2291 94.6535C75.2361 94.9336 73.3268 93.64 73.0443 91.6297L71.8872 83.3968C71.8469 83.1096 71.7203 82.9321 71.3944 82.7827C67.7104 81.1528 65.6236 77.1507 66.8657 72.9736C67.639 70.522 69.5756 68.395 72.0992 67.5522C77.4185 65.6332 82.8664 68.9677 83.5795 74.0414C83.9697 76.8176 82.8382 79.6124 80.7615 81.4662Z"
      fill="white"
    />
    <path
      d="M37.408 59.0097C38.9891 56.7957 41.5452 55.1418 44.475 54.73L100.533 46.8516C106.295 46.0418 111.642 50.0707 112.451 55.8328L117.9 94.6045C118.71 100.367 114.681 105.713 108.919 106.523L55.3029 114.058"
      stroke="#4A4A4A"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M96.4312 47.428L94.6058 34.4389C92.7528 21.2546 80.5002 12.0216 67.3158 13.8745C54.1315 15.7274 44.8008 27.9938 46.6538 41.1781L48.4792 54.1672L58.0501 52.8221L56.2246 39.833C55.0991 31.8248 60.6389 24.4732 68.6472 23.3477C76.6555 22.2222 84.0071 27.762 85.1326 35.7703L86.958 48.7593"
      stroke="#4A4A4A"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M78.0807 94.7233C76.1275 94.9978 74.2476 93.6686 73.9594 91.6177L72.779 83.2187C72.7378 82.9257 72.6127 82.7441 72.2923 82.59C68.6698 80.9081 66.601 76.8169 67.7961 72.5657C68.541 70.0708 70.4288 67.9133 72.8994 67.0681C78.1061 65.1412 83.468 68.5705 84.1954 73.7466C84.5935 76.5788 83.4991 79.4215 81.3748 81.3135C81.207 81.5363 81.0391 81.7591 81.0803 82.0521L82.2607 90.451C82.5352 92.4042 81.2059 94.2841 79.155 94.5723L78.0807 94.7233Z"
      stroke="#4A4A4A"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35.5646 66.4393C35.5646 66.4393 26.1701 76.1252 17.2828 77.3743L20.2064 98.1762C20.8103 102.473 23.1172 106.133 26.4604 107.954C29.8036 109.774 39.9462 114.623 40.3643 114.763L42.496 115.759L44.2708 114.214C44.6203 113.867 53.0472 106.508 55.8429 103.724C58.4708 101.164 59.7774 96.9969 59.1597 92.6021L56.2499 71.8978C47.265 73.1605 35.5646 66.4393 35.5646 66.4393Z"
      fill="#8CE563"
      stroke="#4A4A4A"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.8636 91.1013L38.3128 96.6274L47.3779 84.5976"
      stroke="white"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M56.5415 22.9576C51.7329 27.7167 49.3457 34.8243 50.4026 42.3443L51.0751 47.1297"
      stroke="white"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M107.423 64.7881L110.485 86.574"
      stroke="#4A4A4A"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M111.319 92.5156L111.876 96.4767"
      stroke="#4A4A4A"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

PhoneSecurityLockSymbol.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
}

export default PhoneSecurityLockSymbol
